import { DeeplinkKeys } from '@/consts/deepLinks';
import { getContext } from '@/context';

/**
 * Removes task_id query parameter from URL when closing result view
 * that was opened via a notification deeplink.
 */
const removeTaskIdFromUrl = () => {
  try {
    const { params, route } = getContext().general.location.getState();

    // Only remove if task_id exists in URL
    if (!params[DeeplinkKeys.taskId]) {
      return;
    }

    // Create new params without task_id
    const { [DeeplinkKeys.taskId]: _, ...remainingParams } = params;

    getContext().general.location.dispatch({
      route,
      params: remainingParams,
    });
  } catch {
    // SDK not available, silently fail
  }
};

export { removeTaskIdFromUrl };
